// Provincial TD1 for the staff member's Profile province (TD1ON, TD1BC, ... or Quebec TP-1015.3-V),
// on the official fillable PDF. The backend picks the form from the province on the Profile.
import React from "react";
import FillableTaxFormPdf from "./FillableTaxFormPdf";

export default function ProvincialTd1Pdf() {
  return (
    <FillableTaxFormPdf
      itemId="tdon-tax"
      metaPath="/api/registration/me/provincial-td1/meta"
      templatePath="/api/registration/me/provincial-td1/template"
      prefillPath="/api/registration/me/provincial-td1/prefill"
      formLabel="provincial TD1"
    />
  );
}
